import { TourPackage } from "../models/tour-package.model";

export default function getTourPackages(): TourPackage[] {
    return [
        {
            id: "malvan-scuba-adventure",
            name: "Malvan Scuba & Watersports Adventure",
            duration: "3 Days / 2 Nights",
            description: "Explore the thrill of marine life and historical sea forts. Complete water sports package with professional instructors in pristine beaches.",
            price: 6499,
            locations: ["Malvan", "Tarkarli", "Devbag", "Kudal"],
            image: "malvan-scuba.webp",
            highlights: [
                "Scuba Diving at Sindhudurg Fort",
                "Water Sports (Jet Ski, Banana Ride, Bumper Ride, Speed Boat)",
                "Parasailing with speedboat harness",
                "Dolphin Spotting Safari in Devbag",
                "Coastal Cuisine Experience"
            ],
            inclusions: [
                "2 Nights AC accommodation on twin sharing basis",
                "Pick-up and Drop-off from Kudal / Malvan",
                "Breakfast and Dinner (including Konkani specials)",
                "Scuba Diving gear and Underwater video",
                "All sightseeing in AC cab"
            ],
            itinerary: [
                {
                    day: 1,
                    title: "Arrival & Historic Sindhudurg Fort Visit",
                    activities: [
                        "Pick up from Kudal Railway Station or Malvan Bus Stand.",
                        "Check-in to beachside resort at Malvan/Tarkarli.",
                        "Visit the iconic Sindhudurg Fort via ferry.",
                        "Relax at Malvan Beach and enjoy a traditional Malvani seafood dinner."
                    ]
                },
                {
                    day: 2,
                    title: "Scuba Diving & Watersports Extravaganza",
                    activities: [
                        "Early morning transfer to diving site for Scuba Diving with PADI certified guides.",
                        "Receive personalized underwater video and photos.",
                        "Afternoon water sports at Tarkarli: Jet Ski, Banana Ride, Bumper Ride, and Speed Boat.",
                        "Breathtaking sunset parasailing experience over the Arabian Sea."
                    ]
                },
                {
                    day: 3,
                    title: "Dolphin Safari, Devbag Sangam & Departure",
                    activities: [
                        "Morning boat trip for dolphin spotting safari near Devbag beach.",
                        "Visit Devbag Sangam (confluence of Karli river and Arabian sea) and Tsunami Island.",
                        "Check-out and transfer back to Kudal Railway Station or Malvan Bus Stand for onward journey."
                    ]
                }
            ]
        },
        {
            id: "ganpatipule-beach-getaway",
            name: "Ganpatipule Coastal & Beach Getaway",
            duration: "2 Days / 1 Night",
            description: "A perfect blend of spiritual solace and coastal serenity. Visit the self-manifested Ganpati temple and pristine white sand beaches.",
            price: 4799,
            locations: ["Ratnagiri", "Ganpatipule"],
            image: "ganpatipule.webp",
            highlights: [
                "Darshan at Swayambhu Ganpati Temple",
                "Explore Prachin Konkan open-air museum",
                "Panoramic views from Jaigad Fort & Lighthouse",
                "Relaxing at the clean Ganpatipule Beach",
                "Ratnagiri Alphonso Mango Farm Tour (seasonal)"
            ],
            inclusions: [
                "1 Night beach-facing hotel accommodation",
                "Pick-up and Drop-off from Ratnagiri Station / Ganpatipule",
                "Daily Breakfast and local Konkani beverages (Solkadhi)",
                "Sightseeing in an AC sedan car",
                "Museum entrance tickets"
            ],
            itinerary: [
                {
                    day: 1,
                    title: "Temple Blessings, Local Heritage & Beach Relaxation",
                    activities: [
                        "Pick up from Ratnagiri Railway Station and drive to Ganpatipule.",
                        "Check-in at the hotel.",
                        "Visit the Swayambhu Ganpati Temple located right next to the beach.",
                        "Explore the Prachin Konkan Museum to learn about ancient Konkan lifestyle.",
                        "Enjoy a beautiful sunset stroll at Ganpatipule Beach followed by authentic local cuisine."
                    ]
                },
                {
                    day: 2,
                    title: "Fort Exploration, Lighthouse Views & Departure",
                    activities: [
                        "Breakfast at the hotel, then checkout.",
                        "Visit Jaigad Fort situated at the confluence of Shastri River and Arabian Sea.",
                        "Climb the Jaigad Lighthouse for breathtaking panoramic views.",
                        "Stop at Arey Warey twin beaches for scenic photo opportunities.",
                        "Drop-off at Ratnagiri Railway Station by evening."
                    ]
                }
            ]
        },
        {
            id: "sindhudurg-heritage-palaces",
            name: "Sindhudurg Heritage & Coastal Forts Tour",
            duration: "4 Days / 3 Nights",
            description: "Immerse yourself in Maratha history, royal palaces, wooden craftsmanship, and spectacular sea-cliff temples.",
            price: 9999,
            locations: ["Kudal", "Sawantwadi", "Vengurla", "Malvan", "Kunkeshwar"],
            image: "sawantwadi-palace.webp",
            highlights: [
                "Visit Sawantwadi Palace & Ganjifa art demonstration",
                "Explore Pinguli Wooden Puppetry Museum",
                "Kunkeshwar Temple (often called South Kashi) right on the sea cliff",
                "White-sand Sagareshwar beach and Vengurla Port",
                "Vijaydurg Fort - the impregnable sea fort"
            ],
            inclusions: [
                "3 Nights premium resort / heritage home-stay stay",
                "All transfers and local sightseeing in AC Innova / SUV",
                "All meals included (Traditional breakfast, lunch, and dinner)",
                "Local expert guide for fort tours",
                "Puppetry show and palace entry tickets"
            ],
            itinerary: [
                {
                    day: 1,
                    title: "Sawantwadi Royalty & Traditional Art",
                    activities: [
                        "Pick up from Kudal or Sawantwadi Road station.",
                        "Check-in at a heritage homestay.",
                        "Visit Sawantwadi Palace, meet royal artists making traditional Ganjifa cards, and walk around Moti Talao.",
                        "Visit the Pinguli Puppetry Art Gallery in evening."
                    ]
                },
                {
                    day: 2,
                    title: "Sea-Cliff Devotion & Pristine Beaches",
                    activities: [
                        "Travel north to visit the spectacular Kunkeshwar Shiva Temple, built right on the beach rocks.",
                        "Relax at Devgad Beach and visit Devgad Fort.",
                        "Savor the world-famous Devgad Alphonso Mango products (in season) or local desserts."
                    ]
                },
                {
                    day: 3,
                    title: "Impregnable Vijaydurg & Vengurla Port",
                    activities: [
                        "Guided exploration of Vijaydurg Fort, featuring double-fortified walls and an underwater wall.",
                        "Drive back via Vengurla to visit the historic Vengurla Lighthouse and Vengurla Jetty.",
                        "Sunset walk at Sagareshwar Beach."
                    ]
                },
                {
                    day: 4,
                    title: "Moti Talao & Departure",
                    activities: [
                        "Enjoy a final Konkani breakfast.",
                        "Souvenir shopping for local cashews, wooden toys, and spices in Sawantwadi market.",
                        "Transfer to Kudal / Sawantwadi Railway Station for departure."
                    ]
                }
            ]
        },
        {
            id: "amboli-hills-monsoon",
            name: "Amboli Hills & Waterfalls 1-Day Gateway",
            duration: "1 Day",
            description: "A quick mist-filled escape to the wettest place in Maharashtra. Witness roaring waterfalls, river origins, and deep fog-covered valleys in a single day.",
            price: 2499,
            locations: ["Kudal", "Sawantwadi", "Mumbai", "Thane", "Navi Mumbai", "Kankavli"],
            image: "amboli-hills.webp",
            highlights: [
                "Amboli Giant Waterfall soak",
                "Hiranyakeshi River Origin Temple visit",
                "Roaring Nangartas Waterfall view",
                "Sunset from Kavlesad Point (Grand Canyon of Konkan)",
                "Scenic drive through fog-covered Amboli Ghat"
            ],
            inclusions: [
                "Sightseeing in a private AC cab from Kudal / Sawantwadi",
                "Traditional home-cooked Konkani lunch",
                "All entry fees and parking charges",
                "Dedicated driver-cum-guide"
            ],
            itinerary: [
                {
                    day: 1,
                    title: "Full-Day Amboli Exploration",
                    activities: [
                        "09:00 AM - Pickup from Kudal Railway Station / Sawantwadi and drive up the beautiful Amboli Ghat.",
                        "10:30 AM - Spend time enjoying the roaring waters of the famous Amboli Giant Waterfall.",
                        "12:30 PM - Explore the calm cave temple at Hiranyakeshi, the origin point of the river.",
                        "01:30 PM - Enjoy a delicious local vegetarian or non-vegetarian Konkani lunch.",
                        "03:00 PM - Visit Nangartas Waterfall, a deep rocky gorge where the water falls with a roaring sound.",
                        "04:30 PM - Witness the dramatic valley views and reverse waterfall mist at Kavlesad Point.",
                        "06:00 PM - Return drive and drop-off at Kudal / Sawantwadi Railway Station."
                    ]
                }
            ]
        }
    ];
}
